import { ReduxActionType } from 'types';

type ActionTypes = {
  FETCH_MEMBER_START: ReduxActionType;
  FETCH_MEMBER_SUCCESS: ReduxActionType;
  FETCH_MEMBER_FAILURE: ReduxActionType;
  CLEAR_SELECTED_MEMBER: ReduxActionType;

  FETCH_MEMBER_SEARCH_START: ReduxActionType;
  FETCH_MEMBER_SEARCH_FAILURE: ReduxActionType;

  SET_ORG_LIST_BY_BOUNDARY_START: ReduxActionType;
  SET_ORG_LIST_BY_BOUNDARY_SUCCESS: ReduxActionType;
  SET_ORG_LIST_BY_BOUNDARY_FAILURE: ReduxActionType;

  REMOVE_ERROR: ReduxActionType;
};

export const MembersActionTypes: ActionTypes = {
  FETCH_MEMBER_START: '@@FETCH_MEMBER_START',
  FETCH_MEMBER_SUCCESS: '@@FETCH_MEMBER_SUCCESS',
  FETCH_MEMBER_FAILURE: '@@FETCH_MEMBER_FAILURE',
  FETCH_MEMBER_SEARCH_START: '@@FETCH_MEMBER_SEARCH_START',
  FETCH_MEMBER_SEARCH_FAILURE: '@@FETCH_MEMBER_SEARCH_FAILURE',
  CLEAR_SELECTED_MEMBER: '@@CLEAR_SELECTED_MEMBER',

  SET_ORG_LIST_BY_BOUNDARY_START: '@@SET_ORG_LIST_BY_BOUNDARY_START',
  SET_ORG_LIST_BY_BOUNDARY_SUCCESS: '@@SET_ORG_LIST_BY_BOUNDARY_SUCCESS',
  SET_ORG_LIST_BY_BOUNDARY_FAILURE: '@@SET_ORG_LIST_BY_BOUNDARY_FAILURE',

  REMOVE_ERROR: '@@REMOVE_ERROR'
};

export interface MembersState {
  loading: boolean;
  error: string | undefined;
  paginationInfo: Object | undefined;
  selected: Array<any> | undefined | null;
  orgListByBoundary: Array<any> | undefined;
}

export interface CreateMemberState {
  loading: boolean;
  error: string | undefined;
  data: any;
}

export interface Params {
  role?: string;
  orderBy?: string;
  name?: string;
  limit?: number;
  offset?: number;
  fields?: string;
  include?: string;
  filter?: string;
  extent?: string;
  eId?: string;
  seed?: string;
  order?: string;
}
